export default "__VITE_ASSET__8a5c2c87__"